export const STATUS_COLORS = {
  draft: 'bg-slate-100 text-slate-700',
  sent: 'bg-blue-100 text-blue-700',
  viewed: 'bg-indigo-100 text-indigo-700',
  accepted: 'bg-emerald-100 text-emerald-700',
  revision_requested: 'bg-amber-100 text-amber-800',
  rejected: 'bg-red-100 text-red-700',
};

export const STATUS_NEXT = {
  draft: ['sent'],
  sent: ['viewed', 'accepted', 'revision_requested', 'rejected'],
  viewed: ['accepted', 'revision_requested', 'rejected'],
  revision_requested: ['sent'],
  accepted: [],
  rejected: [],
};

export function QuoteStatusBadge({ status, t }) {
  return <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_COLORS[status] || STATUS_COLORS.draft}`}>
    {t(`list.status.${status}`, { defaultValue: status || 'draft' })}
  </span>;
}
